import * as S from "./ExerciseTodayBox.style";
import { ExerciseInfo } from "@/components/atoms/ExerciseInfo";

interface ExerciseTodayBoxProps {
  title: string;
  duration: number;
  thumbnailUrl: string;
  isHealthEnterInfo?: boolean;
  onClick: () => void;
}
export const ExerciseTodayBox = ({
  title,
  onClick,
  duration,
  thumbnailUrl,
  isHealthEnterInfo,
}: ExerciseTodayBoxProps) => {
  return (
    <S.ExerciseTodayBox>
      <S.ExerciseTodayTit $isHealthEnterInfo={isHealthEnterInfo}>
        나의 운동 프로그램
        <span>
          '나의 운동 프로그램'은 나의 건강 상태에 맞춤 프로그램으로,
          <br />
          12주(84일) 동안 총 36회 제공됩니다.
        </span>
      </S.ExerciseTodayTit>

      {/* 추천운동 youtube thumbnail */}
      <S.ExerciseToday>
        {thumbnailUrl ? (
          <img src={thumbnailUrl} alt="운동 미리보기" />
        ) : (
          <S.AlertText>
            척추 사진 제출 및 신체기능 검사
            <br />
            참여 후 이용이 가능합니다.
          </S.AlertText>
        )}
      </S.ExerciseToday>
      {/* 운동 정보 및 바로 시작하기 버튼 */}
      <S.ExerciseTodayInfo>
        <ExerciseInfo onClick={onClick} title={title} duration={duration} />
      </S.ExerciseTodayInfo>
    </S.ExerciseTodayBox>
  );
};
